// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 392) return "static/chunks/40756382-273fb56252b731c0.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "b31e81aabe217d6d" + ".js";
};